import Big from 'big.js'

/**
 * @typedef {import('../../../api-v2/js-doc').V1CreateReserveAccountRequest} V1CreateReserveAccountRequest
 * @typedef {import('../../../api-v2/js-doc').V2CreateReserveAccountRequest} V2CreateReserveAccountRequest
 * @typedef {import('../../../api-v2/js-doc').V1ReserveAccountResponse} V1ReserveAccountResponse
 * @typedef {import('../../../api-v2/js-doc').V2ReserveAccountResponse} V2ReserveAccountResponse
 */
export class ReserveAccountFundsMapper {
  /**
   * @param {V1CreateReserveAccountRequest} v1RequestBody - Represents the V1 create request body
   * @param {V1ReserveAccountResponse=} v1ResponseBody - Represents the V1 create response body
   * @param {boolean} ingestingFromV2 - Whether we're ingesting into V2 then to V1
   * @returns {V2CreateReserveAccountRequest}
   */
  static v1ToCreateRequest (v1RequestBody, v1ResponseBody, ingestingFromV2 = false) {
    return {
      __ingestThrough: ingestingFromV2,
      __v1Payload: v1RequestBody,
      amount: v1RequestBody.amount,
      id: v1ResponseBody?.id,
      note: v1RequestBody.notes,
    }
  }

  /**
   * @param {V2ReserveAccountResponse} v2ReserveAccountFunds - V2 reserve account funds
   * @returns {V1ReserveAccountResponse}
   */
  static v2ReserveAccountFundsToV1 (v2ReserveAccountFunds) {
    return {
      amount: new Big(v2ReserveAccountFunds.amount).toNumber(),
      changelog_notes: v2ReserveAccountFunds.note,
      client_id: v2ReserveAccountFunds.client_id,
      created_at: new Date(v2ReserveAccountFunds.createdAt).toISOString(),
      firebase_key: null,
      id: v2ReserveAccountFunds.id,
      metadata: {},
      notes: v2ReserveAccountFunds.note,
      updated_at: new Date(v2ReserveAccountFunds.updatedAt).toISOString(),
      updated_by: v2ReserveAccountFunds.updatedBy?.email,
    }
  }
}
  
